import { atom } from 'recoil'

export type UIAtomType = {
  sidebar: {
    active: number
  }
}

const DEFAULT_STATE = {
  sidebar: {
    active: 0,
  },
}

export const uiAtom = atom<UIAtomType>({
  key: 'uiAtom',
  default: DEFAULT_STATE,
})
